import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setMsg("Token manquant"); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(r => { setStatus("ok"); setMsg(r.data.message); })
      .catch(e => { setStatus("error"); setMsg(e.response?.data?.detail || "Erreur"); });
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="verify-email-page">
      {status === "loading" && <Loader2 className="w-16 h-16 animate-spin text-[#7AC143] mx-auto" />}
      {status === "ok" && <CheckCircle2 className="w-20 h-20 text-[#7AC143] mx-auto" />}
      {status === "error" && <AlertCircle className="w-20 h-20 text-red-500 mx-auto" />}
      <h1 className="text-3xl font-black tracking-tighter mt-6">{status === "ok" ? "Email vérifié !" : status === "error" ? "Erreur" : "Vérification..."}</h1>
      <p className="text-[#4B634B] mt-3">{msg}</p>
      {status === "ok" && (
        <Link to="/auth" className="inline-block mt-8 bg-[#7AC143] hover:bg-[#67BC2A] text-white rounded-full px-7 py-3 font-semibold" data-testid="goto-login-btn">
          Se connecter
        </Link>
      )}
    </div>
  );
}
